<template>
  <Highcharts
    ref="highCharts"
    v-bind="$attrs"
    :options="mergedOption"
    v-on="$listeners"
  />
</template>

<script>
import { deepMerge } from '@/utils/object';
import lang from '@/mixins/lang';

import Highcharts from '@@/common/stats/Highcharts';

export default {
  name: 'BaseChart',
  components: {
    Highcharts,
  },
  mixins: [lang],
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    baseChartOptions() {
      const isPersian = this.lang === 'fa';
      const align = isPersian ? 'right' : 'left';
      const font = isPersian ? 'IRANSans' : 'EnIRANSans';
      return {
        chart: {
          style: {
            fontFamily: font,
          },
        },
        tooltip: {
          style: {
            textAlign: align,
          },
          useHTML: true,
          pointFormat: isPersian
            ? '<span dir="rtl">{series.name}: <b dir="ltr">{point.y}</b></span> <span style="color:{point.color}">\u25CF</span><br/>'
            : '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>',
        },
        legend: {
          rtl: isPersian,
        },
      };
    },
    mergedOption() {
      const result = deepMerge(this.baseChartOptions, this.options);
      return result;
    },
  },
  methods: {
    getChart() {
      return this.$refs.highCharts.chart;
    },
  },
};
</script>
